import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";

let AccessTokenDialog = {
    selector: "vcAccessTokenDialog",
    templateUrl:
        "/angular/components/public-api/access-token-dialog.component.html",
    bindings: {
        accessToken: "=",
        title: "=",
        buttonText: "=?",
    },
    controller: class AccessTokenDialogController {
        // * bindings for typescript compiler *
        public accessToken: string;
        public title: string;
        public buttonText?: string;
        // ************************************

        public confirmButtonText: string;

        private readonly dialog: DialogUtils;
        private readonly toast: ToastUtils;

        constructor(DialogUtils: DialogUtils, ToastUtils: ToastUtils) {
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
        }

        $onInit() {
            this.confirmButtonText =
                this.buttonText && this.buttonText["confirm"]
                    ? this.buttonText["confirm"]
                    : "Close";
        }

        confirm(): void {
            this.dialog.hide();
        }

        copy(): void {
            let copyElement = document.createElement("textarea");
            copyElement.style.position = "fixed";
            copyElement.style.opacity = "0";
            copyElement.textContent = this.accessToken;
            let body = document.getElementsByTagName("body")[0];
            body.appendChild(copyElement);
            copyElement.select();
            document.execCommand("copy");
            body.removeChild(copyElement);
            this.toast.success("Access Token copied");
        }
    },
};
angular
    .module("publicApi", [])
    .component(AccessTokenDialog.selector, AccessTokenDialog);
